<h1 mat-dialog-title>
  {{details.omschrijving}}
  <mat-progress-bar mode="indeterminate" *ngIf="isLoadingDetails"></mat-progress-bar>
</h1>
<div *ngIf="isAlternativeItem" class="alert alert-warning mb-0">Vul een artikelnummer in om diverse velden automatisch in te laten vullen</div>
<mat-dialog-content>
  <div class="row">
    <div class="col-sm">
      <div class="card">
        <div class="card-header">
          Aanvraagcondities
        </div>
        <div class="card-body">
          <div class="card-text">
            <div class="form-group row">
              <label for="OfferteAanvraagOmschrijving" class="col-sm-5 col-form-label">Omschrijving</label>
              <div class="col-sm-7">
                <span id="OfferteAanvraagOmschrijving"
                  class="form-control-plaintext">{{details.offerteAanvraagOmschrijving}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Debiteur" class="col-sm-5 col-form-label">Debiteur</label>
              <div class="col-sm-7">
                <span id="Debiteur" class="form-control-plaintext">{{details.debiteurNaam}}</span>
              </div>
            </div>

            <div class="font-weight-bold kp-heading">Afleverperiode</div>

            <div class="form-group row">
              <label for="VanJaarWeek" class="col-sm-5 col-form-label">Van jaar-week</label>
              <div class="col-sm-7">
                <span id="VanJaarWeek"
                  class="form-control-plaintext">{{details.afleverperiodeVanJaar}}-{{details.afleverperiodeVanWeek}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="TotJaarWeek" class="col-sm-5 col-form-label">Tot jaar-week</label>
              <div class="col-sm-7">
                <span id="TotJaarWeek"
                  class="form-control-plaintext">{{details.afleverperiodeTotJaar}}-{{details.afleverperiodeTotWeek}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="DeadlineInkoop" class="col-sm-5 col-form-label">Deadline inkoop</label>
              <div class="col-sm-7">
                <span id="DeadlineInkoop" class="form-control-plaintext">{{details.deadlineInkoopDate | date:"dd-MM-yyy
                  HH:mm"}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="DeadlineLeverancier" class="col-sm-5 col-form-label">Deadline leverancier</label>
              <div class="col-sm-7">
                <span id="DeadlineLeverancier" class="form-control-plaintext">{{details.deadlineLeverancierDate |
                  date:"dd-MM-yyy HH:mm"}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          Aanvraagregelcondities
        </div>
        <div class="card-body">
          <div class="card-text">
            <div class="form-group row">
              <label for="Referentie" class="col-sm-5 col-form-label">Referentie (id)</label>
              <div class="col-sm-7">
                <span id="Referentie" class="form-control-plaintext">{{details.sourceId}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="GeldigheidKwekersaanbieding" class="col-sm-5 col-form-label">Geldigheid
                kwekersaanbieding</label>
              <div class="col-sm-7">
                <mat-form-field *ngIf="!isDisabled; else elseBlock1">
                  <input id="GeldigheidKwekersaanbieding"
                    [(ngModel)]="details.leverancierDetails.geldigheidKwekersaanbiedingTot" matInput
                    [matDatepicker]="picker" (change)="onChangeGeldigheidKwekersaanbieding($event)">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <ng-template #elseBlock1><span class="form-control-plaintext">{{
                    details.leverancierDetails.geldigheidKwekersaanbiedingTot | date: 'dd-MM-yyyy'
                    }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="Handeltype" class="col-sm-5 col-form-label">Handeltype</label>
              <div class="col-sm-7">
                <span id="Handeltype" class="form-control-plaintext">{{details.handelType}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Verlading" class="col-sm-5 col-form-label">Verlading</label>
              <div class="col-sm-7">
                <span id="Verlading" class="form-control-plaintext">{{details.verladingType}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Stickeren" class="col-sm-5 col-form-label">Stickeren</label>
              <div class="col-sm-3">
                <span id="Stickeren" class="form-control-plaintext">{{details.isSticker | yesno}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Stickeren1" class="col-sm-5 col-form-label">Stickerlocatie</label>
              <div class="col-sm-7">
                <span id="Stickeren1" class="form-control-plaintext">{{details.locatieProductlabelCode1}}</span>
              </div>
              <label for="Stickeren2" class="col-sm-5 col-form-label">&nbsp;</label>
              <div class="col-sm-7">
                <span id="Stickeren2" class="form-control-plaintext">{{details.locatieProductlabelCode2}}</span>
              </div>
              <label for="Stickeren3" class="col-sm-5 col-form-label">&nbsp;</label>
              <div class="col-sm-7">
                <span id="Stickeren3" class="form-control-plaintext">{{details.locatieProductlabelCode3}}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-sm">
      <div class="card">
        <div class="card-header">
          Productkenmerken
        </div>
        <div class="card-body">
          <div class="card-text">

            <div class="form-group row">
              <label for="Kwekerartikel" class="col-sm-5 col-form-label">Artikelnummer</label>
              <div class="col-sm-7">
                <span *ngIf="isDisabled || !isAlternativeItem; else elseEditSupplierAssignedId"
                  id="Kwekerartikel" class="form-control-plaintext">{{details.supplierAssignedId}}</span>
                <ng-template #elseEditSupplierAssignedId>
                  <mat-form-field id="SupplierAssignedId">
                    <input type="text" #supplierAssignedId [formControl]="controlSupplierAssignedId" matInput
                      [(ngModel)]="details.leverancierDetails.supplierAssignedId" [matAutocomplete]="auto" />
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="supplierAssignedIdSelected($event)">
                      <mat-option (onSelectionChange)="supplierAssignedId.value != undefined && onEnter($event)"
                        *ngFor="let option of filteredAssignedIds | async" [value]="option.id">
                        {{option.text}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="Omschrijving" class="col-sm-5 col-form-label">Omschrijving</label>
              <div class="col-sm-7">
                <span *ngIf="details.leverancierDetails.id || isDisabled; else elseEditDescription"
                  class="form-control-plaintext">{{details.leverancierDetails.omschrijving || details.omschrijving}}</span>
                <ng-template #elseEditDescription>
                  <mat-form-field id="Omschrijving">
                    <input type="text" matInput [formControl]="omschrijvingControl" />
                    <span matSuffix *ngIf="omschrijvingControl.invalid">&nbsp; <i class="fa-solid fa-exclamation"
                        style="color: red;"></i></span>
                  </mat-form-field>
                </ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="AantalGevraagd" class="col-sm-5 col-form-label">Aantal gevraagd</label>
              <div class="col-sm-7">
                <span id="AantalGevraagd" class="form-control-plaintext">{{details.aantal}}
                  {{details.aantallenInAanvraagType | lowercase}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Artikel" class="col-sm-5 col-form-label">Artikel</label>
              <div class="col-sm-7">
                <span id="Artikel" class="form-control-plaintext">{{details.hamiplantArtikelNr}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Potmaat" class="col-sm-5 col-form-label">Potmaat</label>
              <div class="col-sm-7">
                <span id="Potmaat" class="form-control-plaintext">{{details.leverancierDetails.potmaat || details.potmaat}}</span>
              </div>
            </div>

            <div class="form-group row">
              <label for="Hoogte" class="col-sm-5 col-form-label">Hoogte</label>
              <div class="col-sm-7">
                <mat-form-field id="Hoogte" *ngIf="!isDisabled; else elseBlock2">

                  <input #heightInput type="text" aria-label="Hoogte" matInput [formControl]="control"
                    [matAutocomplete]="auto">
                  <span matSuffix *ngIf="control.invalid">&nbsp; <i class="fa-solid fa-exclamation"
                      style="color: red;"></i></span>
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (onSelectionChange)="heightInput.value != undefined && onEnter($event)"
                      *ngFor="let option of filteredHeights | async" [value]="option.featureValue | fromVbnS02">
                      {{option.description}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <ng-template #elseBlock2><span class="form-control-plaintext">{{ details.leverancierDetails.hoogte
                    }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="OpmerkingInkoop" class="col-sm-5 col-form-label">Opmerking inkoop</label>
              <div class="col-sm-7">
                <mat-form-field id="OpmerkingInkoop" *ngIf="!isDisabled; else elseBlock3">
                  <textarea matInput [(ngModel)]="details.leverancierDetails.opmerkingInkoop"></textarea>
                </mat-form-field>
                <ng-template #elseBlock3><span class="form-control-plaintext">{{
                    details.leverancierDetails.opmerkingInkoop }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="OpmerkingLeverancier" class="col-sm-5 col-form-label">Opmerking leverancier</label>
              <div class="col-sm-7">
                <mat-form-field id="OpmerkingLeverancier" *ngIf="!isDisabled; else elseBlock4">
                  <textarea matInput [(ngModel)]="details.leverancierDetails.opmerkingLeverancier"></textarea>
                </mat-form-field>
                <ng-template #elseBlock4><span class="form-control-plaintext">{{
                    details.leverancierDetails.opmerkingLeverancier }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="KleurMix" class="col-sm-5 col-form-label">Kleur/Mix</label>
              <div class="col-sm-7">
                <mat-form-field id="KleurMix" *ngIf="!isDisabled; else elseBlock5">
                  <input type="text" matInput [(ngModel)]="details.leverancierDetails.kleur">
                </mat-form-field>
                <ng-template #elseBlock5><span class="form-control-plaintext">{{ details.leverancierDetails.kleur
                    }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="AantalBloemen" class="col-sm-5 col-form-label">Aantal bloemen</label>
              <div class="col-sm-7">
                <mat-form-field id="AantalBloemen" *ngIf="!isDisabled; else elseBlock6">
                  <input type="text" matInput [(ngModel)]="details.leverancierDetails.aantalBloemen">
                </mat-form-field>
                <ng-template #elseBlock6><span class="form-control-plaintext">{{
                    details.leverancierDetails.aantalBloemen }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="AantalTakken" class="col-sm-5 col-form-label">Aantal takken</label>
              <div class="col-sm-7">
                <mat-form-field id="AantalTakken" *ngIf="!isDisabled; else elseBlock7">
                  <input type="text" matInput [(ngModel)]="details.leverancierDetails.aantalTakken">
                </mat-form-field>
                <ng-template #elseBlock7><span class="form-control-plaintext">{{ details.leverancierDetails.aantalTakken
                    }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="Stadium" class="col-sm-5 col-form-label">Stadium</label>
              <div class="col-sm-7">
                <mat-form-field id="Stadium" *ngIf="!isDisabled; else elseBlock8">
                  <input type="text" matInput [(ngModel)]="details.leverancierDetails.stadium">
                </mat-form-field>
                <ng-template #elseBlock8><span class="form-control-plaintext">{{ details.leverancierDetails.stadium
                    }}</span></ng-template>
              </div>
            </div>

            <div class="form-group row">
              <label for="WerkelijkePrijs" class="col-sm-5 col-form-label">Werkelijke prijs</label>
              <div class="col-sm-7">
                  <mat-form-field id="WerkelijkePrijs" *ngIf="!isDisabled; else elseBlock9">
                      <input currencyMask matInput [formControl]="werkelijkePrijsControl">
                      <span matSuffix *ngIf="werkelijkePrijsControl.invalid">
                          &nbsp; <i class="fa-solid fa-exclamation"
                                    style="color: red;"></i>
                      </span>
                  </mat-form-field>
                <ng-template #elseBlock9><span class="form-control-plaintext">{{
                    details.leverancierDetails.werkelijkeInkoopprijs }}</span></ng-template>
              </div>
            </div>

            <ng-template [ngIf]="details.isSticker">

              <div class="form-group row">
                <label for="InclusiefSticker" class="col-sm-5 col-form-label">Inclusief sticker</label>
                <div class="col-sm-7">
                  <mat-checkbox id="InclusiefSticker" [(ngModel)]="details.leverancierDetails.isInclusiefSticker"
                    *ngIf="!isDisabled; else elseBlock10"></mat-checkbox>
                  <ng-template #elseBlock10><span class="form-control-plaintext">{{
                      details.leverancierDetails.isInclusiefSticker | yesno }}</span></ng-template>
                </div>
              </div>

              <ng-template [ngIf]="!details.leverancierDetails.isInclusiefSticker">

                <div class="form-group row" *ngIf="!(details.locatieProductlabelCode1 | isnullorempty)">
                  <label for="Stickerprijs1" class="col-sm-5 col-form-label">Stickerprijs {{
                    details.locatieProductlabelCode1 }}</label>
                  <div class="col-sm-7">
                    <mat-form-field id="Stickerprijs1" *ngIf="!isDisabled; else elseBlock11">
                      <input currencyMask matInput [(ngModel)]="details.leverancierDetails.stickerprijs1">
                    </mat-form-field>
                    <ng-template #elseBlock11><span class="form-control-plaintext">{{
                        details.leverancierDetails.stickerprijs1 }}</span></ng-template>
                  </div>
                </div>

                <div class="form-group row" *ngIf="!(details.locatieProductlabelCode2 | isnullorempty)">
                  <label for="Stickerprijs2" class="col-sm-5 col-form-label">Stickerprijs {{
                    details.locatieProductlabelCode2 }}</label>
                  <div class="col-sm-7">
                    <mat-form-field id="Stickerprijs2" *ngIf="!isDisabled; else elseBlock12">
                      <input currencyMask matInput [(ngModel)]="details.leverancierDetails.stickerprijs2">
                    </mat-form-field>
                    <ng-template #elseBlock12><span class="form-control-plaintext">{{
                        details.leverancierDetails.stickerprijs2 }}</span></ng-template>
                  </div>
                </div>

                <div class="form-group row" *ngIf="!(details.locatieProductlabelCode3 | isnullorempty)">
                  <label for="Stickerprijs3" class="col-sm-5 col-form-label">Stickerprijs {{
                    details.locatieProductlabelCode3 }}</label>
                  <div class="col-sm-7">
                    <mat-form-field id="Stickerprijs3" *ngIf="!isDisabled; else elseBlock13">
                      <input currencyMask matInput [(ngModel)]="details.leverancierDetails.stickerprijs3">
                    </mat-form-field>
                    <ng-template #elseBlock13><span class="form-control-plaintext">{{
                        details.leverancierDetails.stickerprijs3 }}</span></ng-template>
                  </div>
                </div>
              </ng-template>
            </ng-template>

            <div class="form-group row">
              <label for="KwekerGTIN" class="col-sm-5 col-form-label">Kweker EAN</label>
              <div class="col-sm-7">
                <span id="KwekerGTIN" class="form-control-plaintext">{{details.kwekerGTIN || details.kwekerEan}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm">
      <div class="card">
        <div class="card-header">
          Logistiek
        </div>
        <div class="card-body">
          <div class="card-text">
            <div class="form-group row" *ngIf="(details.ladingdragerType1 | containsstring: 'pallet') || (details.ladingdragerType2 | containsstring: 'pallet') || (details.ladingdragerType3 | containsstring: 'pallet')">
              <label for="Dooshoogte" class="col-sm-5 col-form-label">Dooshoogte</label>
              <div class="col-sm-7">
                  <mat-form-field id="Dooshoogte" *ngIf="!isDisabled; else elseBlock14">
                      <!--<input type="number" matInput [(ngModel)]="details.leverancierDetails.dooshoogte">-->
                      <mat-select (selectionChange)="onChangeDooshoogte($event)" [(ngModel)]="details.leverancierDetails.dooshoogte">
                          <mat-option></mat-option>
                          <mat-option *ngFor="let option of dooshoogtes" [value]="option">{{option}} cm</mat-option>
                      </mat-select>
                      <span matSuffix *ngIf="details.leverancierDetails.dooshoogte == null">
                          &nbsp; <i class="fa-solid fa-exclamation"
                                    style="color: red;"></i>
                      </span>
                  </mat-form-field>
                <ng-template #elseBlock14><span class="form-control-plaintext">{{ details.leverancierDetails.dooshoogte
                    | number : '1.0-0' }}</span></ng-template>
              </div>
            </div>

            <div *ngIf="!(details.ladingdragerType1 | isnullorempty)">
                <div class="font-weight-bold kp-heading">Ladingdrager 1: {{details.ladingdragerType1}}</div>
                
                <span class="text-danger" *ngIf="showBeladingValidationMessage">De belading moet volledig ingevuld zijn. Vul de velden aan.</span>

                <div class="form-group row">
                    <label for="FustNr1" class="col-sm-5 col-form-label">Fust</label>
                    <div class="col-sm-7">
                        <mat-form-field id="FustNr1" *ngIf="!isDisabled; else elseBlock15">
                            <mat-select [(ngModel)]="details.leverancierDetails.fustNr1" (selectionChange)="onChangeFustNr()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let fust of fusten" [value]="fust.id" matTooltip="{{ fust.id }}. {{ fust.naam }} ({{ fust.alfa }})">
                                    <span>{{ fust.id }}. {{ fust.naam }}</span>
                                    <small *ngIf="!(fust.alfa | isnullorempty)"> ({{ fust.alfa }})</small>
                                </mat-option>
                            </mat-select>
                            <span matSuffix *ngIf="details.leverancierDetails.fustNr1 == null">
                                &nbsp; <i class="fa-solid fa-exclamation"
                                          style="color: red;"></i>
                            </span>
                        </mat-form-field>
                        <ng-template #elseBlock15>
                            <span class="form-control-plaintext">
                                {{
                                displayFn(selectedFust1)
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="Belading1" class="col-sm-5 col-form-label">
                        Belading
                        <span matSuffix *ngIf="showBeladingValidationMessage">
                            &nbsp; <i class="fa-solid fa-exclamation"
                                      style="color: red;"></i>
                    </span>
                    </label>
                    <div class="col-sm-7">
                        <mat-form-field class="belading" id="Belading1" appearance="fill"
                                        *ngIf="!isDisabled; else elseBlock16">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager1">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.fustenPerLaag1">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.stuks1">
                        </mat-form-field>
                        <ng-template #elseBlock16>
                            <span class="form-control-plaintext">
                                {{
                        details.leverancierDetails.aantalLagenPerLadingdrager1
                                }}x{{
                        details.leverancierDetails.fustenPerLaag1
                                }}x{{ details.leverancierDetails.stuks1 }}
                            </span>
                        </ng-template>
                        <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="MaxHoogteLadingdrager1" class="col-sm-5 col-form-label">Maximale hoogte</label>
                    <div class="col-sm-7">
                        <mat-form-field id="MaxHoogteLadingdrager1" *ngIf="false; else elseBlock20">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager1">
                        </mat-form-field>
                        <ng-template #elseBlock20>
                            <span class="form-control-plaintext">
                                {{
                      details.leverancierDetails.maxHoogteLadingdrager1
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div *ngIf="!(details.ladingdragerType2 | isnullorempty)">
                <div class="font-weight-bold kp-heading">Ladingdrager 2: {{details.ladingdragerType2}}</div>

                <div class="form-group row">
                    <label for="FustNr2" class="col-sm-5 col-form-label">Fust</label>
                    <div class="col-sm-7">
                        <mat-form-field id="FustNr2" *ngIf="!isDisabled; else elseBlock21">
                            <mat-select [(ngModel)]="details.leverancierDetails.fustNr2" (selectionChange)="onChangeFustNr()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let fust of fusten" [value]="fust.id" matTooltip="{{ fust.id }}. {{ fust.naam }} ({{ fust.alfa }})">
                                    <span>{{ fust.id }}. {{ fust.naam }}</span>
                                    <small *ngIf="!(fust.alfa | isnullorempty)"> ({{ fust.alfa }})</small>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ng-template #elseBlock21>
                            <span class="form-control-plaintext">
                                {{
                                displayFn(selectedFust2)
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="Belading2" class="col-sm-5 col-form-label">Belading</label>
                    <div class="col-sm-7">
                        <mat-form-field class="belading" id="Belading2" appearance="fill"
                                        *ngIf="!isDisabled; else elseBlock22">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager2">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.fustenPerLaag2">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.stuks2">
                        </mat-form-field>
                        <ng-template #elseBlock22>
                            <span class="form-control-plaintext">
                                {{
                      details.leverancierDetails.aantalLagenPerLadingdrager2
                                }}x{{
                      details.leverancierDetails.fustenPerLaag2
                                }}x{{ details.leverancierDetails.stuks2 }}
                            </span>
                        </ng-template>
                        <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="MaxHoogteLadingdrager2" class="col-sm-5 col-form-label">Maximale hoogte</label>
                    <div class="col-sm-7">
                        <mat-form-field id="MaxHoogteLadingdrager2" *ngIf="false; else elseBlock26">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager2">
                        </mat-form-field>
                        <ng-template #elseBlock26>
                            <span class="form-control-plaintext">
                                {{
                      details.leverancierDetails.maxHoogteLadingdrager2
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div *ngIf="!(details.ladingdragerType3 | isnullorempty)">
                <div class="font-weight-bold kp-heading">Ladingdrager 3: {{details.ladingdragerType3}}</div>

                <div class="form-group row">
                    <label for="FustNr3" class="col-sm-5 col-form-label">Fust</label>
                    <div class="col-sm-7">
                        <mat-form-field id="FustNr3" *ngIf="!isDisabled; else elseBlock27">
                            <mat-select [(ngModel)]="details.leverancierDetails.fustNr3" (selectionChange)="onChangeFustNr()">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let fust of fusten" [value]="fust.id" matTooltip="{{ fust.id }}. {{ fust.naam }} ({{ fust.alfa }})">
                                    <span>{{ fust.id }}. {{ fust.naam }}</span>
                                    <small *ngIf="!(fust.alfa | isnullorempty)"> ({{ fust.alfa }})</small>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ng-template #elseBlock27>
                            <span class="form-control-plaintext">
                                {{
                                displayFn(selectedFust3)
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="Belading3" class="col-sm-5 col-form-label">Belading</label>
                    <div class="col-sm-7">
                        <mat-form-field class="belading" id="Belading3" appearance="fill"
                                        *ngIf="!isDisabled; else elseBlock28">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.aantalLagenPerLadingdrager3">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.fustenPerLaag3">
                        </mat-form-field>
                        <span *ngIf="!isDisabled">x</span>
                        <mat-form-field class="belading" appearance="fill" *ngIf="!isDisabled;">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.stuks3">
                        </mat-form-field>
                        <ng-template #elseBlock28>
                            <span class="form-control-plaintext">
                                {{
                      details.leverancierDetails.aantalLagenPerLadingdrager3
                                }}x{{
                      details.leverancierDetails.fustenPerLaag3
                                }}x{{ details.leverancierDetails.stuks3 }}
                            </span>
                        </ng-template>
                        <span style="font-size: small;"><code>Lagen/drager</code> x <code>Fusten/laag</code> x <code>Inhoud/fust</code></span>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="MaxHoogteLadingdrager3" class="col-sm-5 col-form-label">Maximale hoogte</label>
                    <div class="col-sm-7">
                        <mat-form-field id="MaxHoogteLadingdrager3" *ngIf="false; else elseBlock32">
                            <input type="number" matInput [(ngModel)]="details.leverancierDetails.maxHoogteLadingdrager3">
                        </mat-form-field>
                        <ng-template #elseBlock32>
                            <span class="form-control-plaintext">
                                {{
                      details.leverancierDetails.maxHoogteLadingdrager3
                                }}
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          Afbeeldingen
        </div>
        <div class="card-body">
          <div class="card-text">
            <div id="photoCarouselIndicators" class="kp-carousel carousel slide"
              *ngIf="details.photos != undefined && details.photos.length > 0; else elseBlock33" data-ride="carousel">
              <ol *ngIf="details.photos != undefined && details.photos.length > 1" class="carousel-indicators">
                <li data-target="#photoCarouselIndicators" data-slide-to="0"
                  *ngFor="let fotoUrl of details.photos; let first = first;" [class.active]="first"></li>
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let fotoUrl of details.photos; let first = first;"
                  [class.active]="first">
                  <img src="{{fotoUrl}}" class="d-block w-100" alt="Productfoto"
                    onerror="this.src='./assets/img/image-not-available.png';">
                </div>
              </div>
              <a *ngIf="details.photos != undefined && details.photos.length > 1" class="carousel-control-prev"
                href="#photoCarouselIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Vorige</span>
              </a>
              <a *ngIf="details.photos != undefined && details.photos.length > 1" class="carousel-control-next"
                href="#photoCarouselIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Volgende</span>
              </a>
            </div>
            <ng-template #elseBlock33>Geen afbeeldingen beschikbaar.</ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" mat-dialog-close>Annuleren</button>
  <button mat-raised-button (click)="openNewAanvraagRegel(details.id)" *ngIf="!isLoadingDetails && !isAlternativeItem"
    [disabled]="isDisabled || control.invalid">Alternatief aanbieden</button>
  <button mat-raised-button color="accent" (click)="saveRegelDetails(LeverancierStatus.NietLeverbaarUitverkocht)"
    [disabled]="isDisabled" *ngIf="!isLoadingDetails && !isAlternativeItem">Niet leverbaar</button>
  <button mat-raised-button class="mat-primary-2" (click)="saveRegelDetails(LeverancierStatus.Voltooid)"
          [disabled]="isDisabled || control.invalid" *ngIf="!isLoadingDetails">
      Voltooien
      <span matSuffix *ngIf="isButtonDisabled" title="Nog niet alle velden zijn juist ingevuld. Vul aan waar nodig.">
          <i class="fa-solid fa-exclamation"
                    style="color: red;"></i>
      </span>
  </button>
</mat-dialog-actions>